// src/components/MobileMenu.js
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, fonts, fontSizes, fontWeights, mq, space, ease, duration } from '../styles/tokens';
import { Icon } from './Icon';

const NAV_LINKS = [
  { href: '#home',    label: 'Home' },
  { href: '#about',   label: 'About' },
  { href: '#work',    label: 'Work' },
  { href: '#skills',  label: 'Skills' },
  { href: '#contact', label: 'Contact' },
];

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${colors.bg};
  z-index: 99;
  display: flex;
  flex-direction: column;
  padding: ${space[8]} ${space[5]};
  opacity: ${(p) => (p.$open ? 1 : 0)};
  pointer-events: ${(p) => (p.$open ? 'auto' : 'none')};
  transition: opacity ${duration.base} ${ease.soft};
  ${mq.md} { display: none; }
`;

const CloseButton = styled.button`
  position: absolute;
  top: ${space[4]};
  right: ${space[4]};
  color: ${colors.text};
  padding: ${space[1]};
`;

const LinkList = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${space[4]};
  flex: 1;
`;

const NavLink = styled.a`
  font-family: ${fonts.sans};
  font-size: ${fontSizes.lg};
  font-weight: ${fontWeights.semibold};
  color: ${colors.text};
  &:hover { color: ${colors.accent}; }
`;

const SocialRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${space[4]};
  padding-bottom: ${space[4]};
  a {
    color: ${colors.textDim};
    padding: ${space[1]};
    &:hover { color: ${colors.accent}; }
  }
`;

export function MobileMenu({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  const handleLinkClick = () => onClose();

  return (
    <Overlay $open={open} aria-hidden={!open}>
      <CloseButton onClick={onClose} aria-label="Close menu">
        <Icon name="close" size={28} />
      </CloseButton>
      <LinkList aria-label="Mobile">
        {NAV_LINKS.map((l) => (
          <NavLink key={l.href} href={l.href} onClick={handleLinkClick}>{l.label}</NavLink>
        ))}
      </LinkList>
      <SocialRow>
        <a href="https://github.com/Fabiolillman" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><Icon name="github" /></a>
        <a href="https://www.linkedin.com/in/fabio-lillman/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><Icon name="linkedin" /></a>
      </SocialRow>
    </Overlay>
  );
}
